const downloadContent = (content, fileName, mimeType = 'application/octet-stream') => {
    const link = document.createElement('a');

    if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(new Blob([content], { type: mimeType }), fileName);
    }
    else if (URL && 'download' in link) {
        //html5 A[download]
        link.href = URL.createObjectURL(new Blob([content], { type: mimeType }));
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        
        // Trigger the download
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }
    else {
        location.href = 'data:application/octet-stream,' + encodeURIComponent(content);
    }
};

export const downloadHelper = {
    downloadContent,
};
